import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import PrepaymentPageUI from './PrepaymentPageUI.js'

class PrepaymentPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      loan: null,
      prepayment: null,
      repaymentGoodStanding: null,
      repaymentPencilClickMode: false,
      repaymentClearDataClickMode: false
    }
  }

  render() {
    return (
      <PrepaymentPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        loan={this.state.loan}
        account={this.state.account}
        prepayment={this.state.prepayment}
        repaymentGoodStanding={this.state.repaymentGoodStanding}
        repaymentPencilClickMode={this.state.repaymentPencilClickMode}
        onRepaymentPencilClick={() => this.setState({ repaymentPencilClickMode: true })}
        onRepaymentPencilCancelClick={() => this.setState({ repaymentPencilClickMode: false })}

        repaymentClearDataClickMode={this.state.repaymentClearDataClickMode}
        onRepaymentClearDataClick={() => this.setState({ repaymentClearDataClickMode: true })}
        onRepaymentClearDataCancelClick={() => this.setState({ repaymentClearDataClickMode: false })}
        onRefreshClick={this.onRefreshClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getLoan(context)
    this.getPrepayment(context)
  }

  getLoan(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}`,
      cacheKey: CacheKeys.Loan(this.props.match.params.loanId),
      callback: this.getLoanCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getLoanCallback = (response) => {
    let context = this.props.context
    this.setState({ errorList: response.errorList, loan: response.loan })
    this.getAccount(context, response.loan.accountId)
  }

  getAccount(context, accountId) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${accountId}`,
      cacheKey: CacheKeys.Account(accountId),
      callback: this.getAccountCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getAccountCallback = (response) => {
    this.setState({ account: response.account })
  }

  getPrepayment(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}/prepayments`,
      cacheKey: CacheKeys.Prepayment(this.props.match.params.loanId),
      callback: this.getPrepaymentCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getPrepaymentCallback = (response) => {
    this.setState({ errorList: response.errorList, prepayment: response.prepayment, repaymentGoodStanding: response.repaymentGoodStanding })
  }

  onRefreshClick = () => {
    let loan = this.state.loan
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Loan(loan.loanId))
    CacheManager.removeObject(CacheKeys.Prepayment(loan.loanId))
    this.setState({
      loan: null,
      prepayment: null,
      repaymentGoodStanding: null,
      errorList: null,
      repaymentPencilClickMode: false,
      repaymentClearDataClickMode: false
    })
    this.getLoan(context)
    this.getPrepayment(this.props.context)
  }
}

export default withRouter(PrepaymentPageSF)
